import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login" }

import { getUserInfo } from "@/services/login";
import store from "@/store";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import router from "@/router";
import { idmAuth } from "@/utils/auth";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();

const token = ref();
// 登录
const login = () => {
  // console.log("login");
  idmAuth().then((res) => {
    if (res === "success") {
      console.log("idm 登录成功");
    }
  });
};
// 获取用户信息
const getUserInfoAPI = (token: string) => {
  getUserInfo(token).then((res: any) => {
    if (res.resultCode === 200) {
      // console.log("userData ", res.data);
      store.commit("setToken", token as string);
      localStorage.setItem("idmToken", token as string);
      store.commit("setUserInfo", res.data);
      const currentPath = router.currentRoute.value;
      const redirectUrl = currentPath.query?.redirectUrl as string;
      window.location.href = `${redirectUrl}?token=${currentPath.query.token}`;
    } else if (res.resultCode === 5002) {
      store.commit("setToken", "");
      localStorage.setItem("idmToken", "");
      store.commit("setUserInfo", {});
      const href = window.location.href;
      const hashIndex = href.indexOf("#");
      let redirectUrl = `${href.slice(hashIndex + 1)}`;
      router.push(`/login${redirectUrl ? "?redirectUrl=" + redirectUrl : ""}`);
    }
  });
};

onMounted(() => {
  // console.log("mounted");
  token.value =
    route.query.token ||
    store.state.base.token ||
    localStorage.getItem("idmToken");
  console.log("token.value :>> ", token.value);
  if (token.value) {
    store.commit("setToken", token.value);
    localStorage.setItem("idmToken", token.value);
    console.log("token isddddd ", token.value);
    getUserInfoAPI(token.value);
  } else {
    store.commit("setToken", "");
    localStorage.setItem("idmToken", "");
    login();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})